import { useMemo } from 'react';

import {
  IEditForm,
  CasEditForm,
  CasRHFDatePicker,
  CasRHFNumberField,
  CasRHFTextField,
  CasStackRow,
} from 'src/compass/shared/components';
import { useSiteProperties } from 'src/compass/application';
import { PropertySchema } from './PropertySchema';

export default function PropertyForm({ row, onSaved }: IEditForm) {
  const defaultValues = useMemo(() => row, [row]);
  // The claim due reminder fields show only while the Show Claim Due Reminders feature flag is on.
  // Hidden fields are not unregistered, so saving still sends their loaded values unchanged.
  const { featureFlags } = useSiteProperties();

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaved}
      entity="Sce/Claims/Property"
      schema={PropertySchema}
    >
      <CasStackRow>
        <CasRHFNumberField label="Claims Dashboard Days Left" name="claimsDashboardDaysLeft" />
      </CasStackRow>
      <CasStackRow>
        <CasRHFNumberField label="Fwd Contract Initial Days" name="fwdContractInitialDays" />
      </CasStackRow>
      {featureFlags.showClaimDueReminders && (
        <>
          <CasStackRow>
            <CasRHFDatePicker
              label="Due Reminders Last Sent"
              name="dueRemindersLastSent"
              canClear
            />
          </CasStackRow>
          <CasStackRow>
            <CasRHFTextField label="Due Warning Days Left" name="dueWarningDaysLeft" />
          </CasStackRow>
          <CasStackRow>
            <CasRHFTextField label="Due Warning Email Subject" name="dueSubject" />
          </CasStackRow>
          <CasStackRow>
            <CasRHFTextField
              label="Due Warning Email Body"
              name="dueBody"
              multiline
              minRows={4}
              maxRows={12}
            />
          </CasStackRow>
        </>
      )}
    </CasEditForm>
  );
}
